import { FormCheckbox, FillTheFieldErrorMessage } from "@/shared/Components";
import { connectionsTableColumnsKeys } from "@/features/ConnectionsTable/model";
import { getConnectionsTableTitles } from "@/features/ConnectionsTable/model/constants";
import type React from "react";
import styles from "./styles.module.scss";

export const ModalContentLayout: React.FC = () => {
  return (
    <div className={styles.container}>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.person}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.person]}
      </FormCheckbox>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.title}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.title]}
      </FormCheckbox>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.connectedAs}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.connectedAs]}
      </FormCheckbox>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.additionalInformation}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.additionalInformation]}
      </FormCheckbox>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.activity}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.activity]}
      </FormCheckbox>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.industry}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.industry]}
      </FormCheckbox>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.role}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.role]}
      </FormCheckbox>
      <FormCheckbox name={`columnsState.${connectionsTableColumnsKeys.birthday}`}>
        {getConnectionsTableTitles()[connectionsTableColumnsKeys.birthday]}
      </FormCheckbox>
      <FillTheFieldErrorMessage name="columnsState.root" />
    </div>
  );
};
